<ng-container *ngIf="isReadOnly; else showInputPassword">
  <div class="p-text-bold-500">
    {{ this.bindingFormControl?.value }}
  </div>
</ng-container>
<ng-template #showInputPassword>
  <sigv-form-control-widget
    [fieldName]="fieldName"
    [bindingFormControl]="bindingFormControl"
  >
    <p-password
      *ngIf="render"
      class="form-control"
      [style]="maxlength ? { width: useWidth } : {}"
      placeholder=" {{
        (placeholder == undefined ? 'Please Enter' : placeholder) | translate
      }}"
      [toggleMask]="toggleMask ?? true"
      [feedback]="feedback ?? false"
      [formControl]="bindingFormControl"
      (blur)="blurEvent($event)"
    ></p-password>
  </sigv-form-control-widget>
</ng-template>
